import { useTranslation } from "react-i18next";
import { DesignTokens } from "melco-ui";
import styled from "styled-components";
import { logStatusToColor, logStatusToName } from "../../helper/logStatus";
import { snakeCase } from "lodash-es";

const { colors } = DesignTokens;

type LogStatusColorProps = {
  color: string;
};

const LogStatusWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !["color"].includes(prop),
})<LogStatusColorProps>`
  color: ${({ color }) => color};
`;

type LogStatusProps = {
  status: string;
};

export const LogStatus: React.FC<LogStatusProps> = ({ status }) => {
  const { t } = useTranslation();

  const statusName = logStatusToName(status);
  const color = colors.feedback[logStatusToColor(status)];

  return (
    <LogStatusWrapper color={color} data-cy-id="log-status">
      {t(`logs.status.${snakeCase(statusName)}`)}
    </LogStatusWrapper>
  );
};
